import React, { useCallback } from 'react';
import { CollapseSection } from '@framework-controls/core';
import css from '../AddVehicle.module.scss';
import { NewVehicle, SpecData, ascCtaInteractionInput, ascElementConfigurationInput } from 'src/models';
import ComponentList from './ComponentList/ComponentList';
import { IPropertyList } from '../DesktopPane/PropertyOptions/PropertyOptions';
import { ascCtaInteraction, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';

interface IProps {
    id: string;
    header: string;
    propertyList: IPropertyList[] | [];
    newVehicle: NewVehicle | undefined;
    click: (target: EventTarget | string, id?: string) => void;
    open: boolean;
    selected: string;
    allOptions: NewVehicle;
    height?: string;
    width?: string;
    otherList?: string[];
    pane: string;
    theme: string;
    defaultLen: number;
    Itype: string | undefined;
    makesBuilt: boolean;
    modelsBuilt: boolean;
    yearsBuilt: boolean;
    currentMainPane: string;
    vinSpecFlag: string;
    vehicleSpecs?: SpecData;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
}

const PropertyDropDown = (props: IProps) => {
    const onClick = useCallback((target: EventTarget | string, id?: string) => {
        props.click(target, id);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'itemlist',
            elementText: target.toString(),
            elementColor: '',
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'dropdown_menu',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        const ascVehicle = {
            id: '',
            vin: props.newVehicle?.vin ?? '',
            makeCode: '',
            make: props.newVehicle?.make ?? '',
            model: props.newVehicle?.model ?? '',
            imagePath: '',
            year: props.newVehicle?.year ?? '',
            color: props.newVehicle?.color ?? '',
            prevMileage: 0,
            style: props.newVehicle?.trim ?? '',
            prevRoDate: '',
            nextAppt: '',
            lastAdv: '',
            lastAdvName: '',
            lastAdvImage: '',
            lastTrans: '',
            lastTransLit: '',
            nameId: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, target, [{...ascVehicle}]);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: target.toString(),
            elementType: 'item_details',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, target);
    }, [props.click, props.newVehicle]);

    let hideIcon = false;
    switch (props.id) {
        case 'makeDropDown':
        case 'yearDropDown':
        case 'modelDropDown': {
            if (props.vinSpecFlag === 'R') {
                hideIcon = true;
            }
            break;
        }
        default:
            break;
    }

    return (
        <CollapseSection
            startCollapsed
            header={props.header}
            className={css.collapse}
            overrideCollapse={props.selected ? undefined : !!props.open}
            headerClass={props.selected ? css.collapseHeader : css.collapseHeader2}
            dividerClass={css.divider}
            iconClass={!hideIcon ? (props.selected ? css.icon : css.icon2) : css.icon2}
            // iconClass={css.icon}

        >
            <ComponentList
                list={props.propertyList}
                click={onClick}
                height={props.height}
                width={props.width}
                selectedOptions={props.allOptions}
                otherList={props.otherList}
                pane={props.pane}
                theme={props.theme}
                defaultLen={props.defaultLen}
                Itype={props.Itype}
                makesBuilt={props.makesBuilt && props.open}
                modelsBuilt={props.modelsBuilt && props.open}
                yearsBuilt={props.yearsBuilt && props.open}
                currentMainPane={props.currentMainPane}
                vehicleSpecs={props.vehicleSpecs}
                sessionId = {props.sessionId}
                lexusMCLaunched = {props.lexusMCLaunched}
                lexusTDMCLaunched = {props.lexusTDMCLaunched}
                toyotaMCLaunched = {props.toyotaMCLaunched}
                toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
            />
        </CollapseSection>
    );
};

export default PropertyDropDown;
